import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { News } from '../../core/models/news.interface';
import { ImageService } from '../../core/services/image.service';

@Component({
  selector: 'app-news-grid',
  templateUrl: './news-grid.component.html',
  styleUrls: ['./news-grid.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class NewsGridComponent implements OnInit {
  @Input() category: string = '';
  @Input() articles: News[] = [];
  @Input() columns: number = 3;

  constructor(
    private imageService: ImageService
  ) { }

  ngOnInit() {
    // Precargar imágenes de los artículos
    this.articles.forEach(article => {
      const imageUrl = this.getImageSrc(article);
      if (imageUrl) {
        this.imageService.checkImageExists(imageUrl);
      }
    });
  }

  // Método para obtener la URL de la imagen como src para el tag img
  getImageSrc(article: News): string | null {
    return this.imageService.getImageSrc(article);
  }
}
